import { build } from './build-info';
import { Environment } from './environment.type';

export const environment: Environment = {
    build,
    stage: 'sandbox',
    LOGIN_URL: 'https://sandbox-login.bannerflow.com',
    CLIENT_ID: 'slBIaAqltmegSyVk4HY33YYmM2sjjK4Q',
    API_URLS: ['https://sandbox-api.bannerflow.com/agent-bff'],
    AGENT_BFF_URL: 'https://sandbox-api.bannerflow.com/agent-bff',
    AGENT_NAME: 'bannerflow-demo-agent'
};
